var collapsible_list_pair_default = {
  "container": "_3ZbgU",
  "title": "P0Hw-",
  "viewerContainer": "b8Go-",
  "titleContainer": "M-ve7",
  "expandIcon": "xDqbp",
  "dndIcon": "CQM5W",
  "RTL": "ZidMw",
  "LTR": "b-xIP",
  "itemContainer": "_8pntO",
  "itemContainerViewer": "IaxG0",
  "mouseDown": "F40YH",
  "innerEditor": "HSkhK",
  "item": "me2dh",
  "floatingAddPluginMenuWrapper": "jx-ow",
  "childrenHidden": "lN4Q3"
};
export {
  collapsible_list_pair_default as default
};
//# sourceMappingURL=collapsible-list-pair-scss.js.map
